import ky from "ky";
import { assertCurrentSession, sessionRevision, sessionSignal } from "@/lib/session-request-scope";

export const api = ky.create({
  prefix: "/api/v1",
  credentials: "include",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
  hooks: {
    init: [
      (options) => {
        options.context = { ...options.context, sessionRevision: sessionRevision() };
        options.signal = options.signal
          ? AbortSignal.any([options.signal, sessionSignal()])
          : sessionSignal();
      },
    ],
    afterResponse: [
      ({ options }) => {
        assertCurrentSession(Number(options.context.sessionRevision));
      },
    ],
    beforeRetry: [
      ({ options }) => {
        assertCurrentSession(Number(options.context.sessionRevision));
      },
    ],
    beforeError: [
      ({ error, options }) => {
        assertCurrentSession(Number(options.context.sessionRevision));
        return error;
      },
    ],
  },
  parseJson: (text, { request }): unknown => {
    request.signal.throwIfAborted();
    return JSON.parse(text);
  },
});
